module.exports = __webpack_public_path__ + "static/media/detect-v2-left-aligned.351e93a1.svg";